import $ from 'jquery';
import MenuWidget from '../../components/menu-widget';
import VideoModalButton from '../../components/video-modal-button';
$(() => {
    MenuWidget.init();
    VideoModalButton.init();
});
